import type { ColumnDefinition } from "@frui.ts/dataviews/dist";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import RoadsViewModel from "viewModels/timeCharges/distributorEnums/roads/roadsViewModel";
import type Road from "entities/road";
import ListView from "views/common/list";

const RoadsView: ViewComponent<RoadsViewModel> = observer(({ vm }) => {
  const columns: ColumnDefinition<Road>[] = [
    { property: "name", title: vm.translateAttribute("name") },
    {
      property: "roadType",
      title: vm.translateAttribute("roadType"),
      valueFormatter: props => vm.translateRoadType(props.value),
    },
  ];

  return <ListView vm={vm} columns={columns} />;
});

registerView(RoadsView, RoadsViewModel);
